import { ComponentType } from 'react'

import { OnboardingExperimentVariant } from './experiment.const'

export enum OnboardingFlowStep {
  HOW_MANY_LEARNERS = 'how-many-learners',
  WORKING_ON = 'working-on',
  WHAT_MATTERS = 'what-matters',
  MATH_FEELING = 'math-feeling',
  // Variant only, between one learner's questions and the next learner's.
  HANDOFF = 'handoff',
  SETUP_READY = 'setup-ready',
  CREATE_ACCOUNT = 'create-account',
  FREE_TRIAL = 'free-trial',
  YOUR_PLAN = 'your-plan',
}

export enum MathFeeling {
  LOVE = 'love',
  OKAY = 'okay',
  STRUGGLE = 'struggle',
}

export interface OnboardingStepProps {
  baseKey: string
}

export interface OnboardingFlowStepConfig {
  id: OnboardingFlowStep
  component: ComponentType<OnboardingStepProps>
  baseKey: string
  isPerLearner: boolean
  path: string
  hideProgress?: boolean
}

export interface LearnerAnswers {
  nickname: string
  grade: string | null
  whatMatters: string[]
  mathFeeling: MathFeeling | null
}

export interface OnboardingFlowState {
  // Which arm of 121026-{no,us}-onboarding-nickname this funnel is walking. Set from the route the
  // middleware rewrote to; the shared /onboarding-flow/* pages cannot tell from the URL.
  arm: OnboardingExperimentVariant
  currentStep: OnboardingFlowStep
  currentLearnerIndex: number
  learnerCount: number
  learners: LearnerAnswers[]
}

export interface GradeGridOption {
  id: string
  label: string
}

export interface GradeGridSection {
  titleKey: string
  isGradeSection: boolean
  options: GradeGridOption[]
}

export interface WhatMattersOption {
  id: string
  labelKey: string
}

export interface MathFeelingOption {
  id: MathFeeling
  labelKey: string
  emoji: string
}
